











































































































































import BarTop from '@/components/BarTop.vue';
import ContainerApp from '@/components/ContainerApp.vue';
import ContainerMenu from '@/components/ContainerMenu.vue';
// @ts-ignore
import {
    navigateToPath,
    getAllTasksForUser,
    getAllTaskTypesForUser,
    getAllNotificationsForUser,
    deleteNotifications,
    // @ts-ignore
} from '@/util';
import FirebaseWeb from '../firebase';
const firebase = new FirebaseWeb();

import Vue from 'vue';
export default Vue.extend({
    name: 'Notification',
    components: {
        BarTop,
        ContainerApp,
        ContainerMenu,
    },
    data() {
        return {
            pageLoading: false,
        };
    },
    computed: {
        notifications() {
            return this.$store.getters.notifications;
        },
        currentUser() {
            // @ts-ignore
            return this.$store.getters.user;
        },
    },
    methods: {
        navigateToHome() {
            navigateToPath('/home');
        },
        deleteNotification(notification: any) {
            this.pageLoading = true;
            firebase
                .deleteNotification(notification)
                .then(() => {
                    return deleteNotifications(
                        notification.id,
                        this.notifications
                    );
                })
                .then((notifications: any) => {
                    this.$store.dispatch('SET_NOTIFICATIONS', notifications);
                })
                .catch((err: any) => {
                    this.$store.dispatch(
                        'SHOW_SNACK',
                        this.$t('toast.error.notification.delete')
                    );
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        // @ts-ignore
        loadPage() {
            return Promise.all([
                // @ts-ignore
                getAllTasksForUser(this.currentUser),
                // @ts-ignore
                getAllTaskTypesForUser(this.currentUser),
                // @ts-ignore
                getAllNotificationsForUser(this.currentUser),
            ]);
        },
    },
    mounted() {
        if (!this.$store.getters.landingVisited) {
            this.pageLoading = true;
            this.loadPage()
                .catch((e) => e)
                .then((response: any) => {
                    // @ts-ignore
                    this.$store.dispatch('SET_TASKS', response[0]);
                    // @ts-ignore
                    this.$store.dispatch('SET_TYPES', response[1]);
                    // @ts-ignore
                    this.$store.dispatch('SET_NOTIFICATIONS', response[2]);
                    // @ts-ignore
                    this.$store.dispatch('LANDING_VISITED', true);
                })
                .catch((err: any) => {
                    // @ts-ignore
                    this.$store.dispatch('SHOW_SNACK', err);
                })
                .then(() => {
                    this.pageLoading = false;
                });
        }
    },
});
